import { z } from 'zod';

import { adminCategorySchema, adminProductSchema } from '../../api';

const variant = z.object({
  name: z.enum(['thumbnail', 'card', 'detail', 'zoom', 'original-display']),
  objectKey: z.string(),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
  contentType: z.literal('image/webp'),
  sizeBytes: z.number().int().positive(),
  etag: z.string().optional(),
});
export const adminMediaSchema = z.object({
  id: z.string(),
  status: z.enum(['initiated', 'uploaded', 'processing', 'ready', 'failed', 'expired', 'deleted']),
  originalFileName: z.string(),
  declaredContentType: z.enum(['image/jpeg', 'image/png', 'image/webp']),
  detectedContentType: z.enum(['image/jpeg', 'image/png', 'image/webp']).optional(),
  originalWidth: z.number().int().positive().optional(),
  originalHeight: z.number().int().positive().optional(),
  originalSizeBytes: z.number().int().positive().optional(),
  variants: z.array(variant),
  ownerType: z.enum(['unassigned', 'product', 'category']),
  ownerId: z.string().optional(),
  altText: z.string().optional(),
  failureCode: z.string().optional(),
  createdAt: z.string(),
  uploadedAt: z.string().optional(),
  processedAt: z.string().optional(),
  expiresAt: z.string().optional(),
  processingVersion: z.number().int().positive(),
  version: z.number().int().positive(),
});
export const mediaPageSchema = z.object({
  items: z.array(adminMediaSchema),
  nextCursor: z.string().nullable(),
});
export const initiationSchema = z.object({
  mediaId: z.string(),
  uploadUrl: z.url(),
  method: z.literal('POST'),
  fields: z.record(z.string(), z.string()),
  expiresAt: z.string(),
  maxSizeBytes: z.number().int().positive(),
});
export const ownerMutationSchema = z.object({
  media: adminMediaSchema,
  product: adminProductSchema.optional(),
  category: adminCategorySchema.optional(),
});
